/**
 * SearchBar Component
 * Search input with view toggle for file browser
 */

import React, { useState, useEffect, useRef } from 'react';

const SearchBar = ({
  onSearch,
  viewMode = 'grid',
  onViewModeChange,
  placeholder = 'Search files and folders...',
  debounceMs = 300
}) => {
  const [query, setQuery] = useState('');
  const debounceRef = useRef(null);

  useEffect(() => {
    // Clear existing timeout
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // Debounce search
    debounceRef.current = setTimeout(() => {
      onSearch(query);
    }, debounceMs);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [query, onSearch, debounceMs]);

  const handleClear = () => {
    setQuery('');
    onSearch('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClear();
    }
  };

  return (
    <div className="rf-search-bar">
      <div className="rf-search-input-wrapper">
        <i className="rf-search-icon fas fa-search"></i>
        <input
          type="text"
          className="rf-search-input"
          placeholder={placeholder}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          aria-label="Search files and folders"
        />
        {query && (
          <button
            className="rf-search-clear"
            onClick={handleClear}
            aria-label="Clear search"
          >
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>

      <div className="rf-view-toggle" role="group" aria-label="View mode">
        <button
          className={`rf-view-toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
          onClick={() => onViewModeChange('grid')}
          title="Grid view"
          aria-pressed={viewMode === 'grid'}
        >
          <i className="fas fa-th-large"></i>
        </button>
        <button
          className={`rf-view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
          onClick={() => onViewModeChange('list')}
          title="List view"
          aria-pressed={viewMode === 'list'}
        >
          <i className="fas fa-list"></i>
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
